// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom'; // Import Link

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <p>
          © JSPlottDesign {new Date().getFullYear()} All Rights reserved. |
          Design: <a href="https://exabyte-webservices.com/" target="_blank" rel="noopener noreferrer">Exabyte Webservices</a> Adaption |
          {/* Use Link with path relative to base path */}
          <Link to="/rechtliches">Rechtliches</Link>
        </p>
      </div>
    </footer>
  );
}

export default Footer;